import { Amplify } from 'aws-amplify';
import { environment } from '../environments/environment';

/**
 * Initialize AWS Amplify with configuration from the environment
 *
 * Note: The environment file is automatically replaced during build
 * based on the configuration specified in angular.json
 */
export function initializeAmplify(): void {
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: environment.cognito.userPoolId,
        userPoolClientId: environment.cognito.userPoolClientId
      }
    }
  });

  console.log('AWS Amplify initialized');
}
